import { render, staticRenderFns } from "./managementCenter.vue?vue&type=template&id=5bf6db19&"
import script from "./managementCenter.vue?vue&type=script&lang=js&"
export * from "./managementCenter.vue?vue&type=script&lang=js&"
import style0 from "./managementCenter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./managementCenter.vue?vue&type=style&index=1&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports